<template>
    <v-data-table
        :headers="headers"
        :items="itemsArr"
        :disable-pagination="true"
        :hide-default-footer="true"
        :disable-sort="true"
        class="data-table">

        <template #item.r_name="{ item }">
          <div style="width:200px">{{ item.r_name }}</div>
        </template>
        <template #item.upload_direction="{ item }">
          <div class="text-center">{{ item.upload_direction }}</div>
        </template>
        <template #item.assetData.r_name="{ item }">
          <div style="width:180px">{{ item.assetData.r_name }}</div>
        </template>
        <template #item.assetData.upload_direction="{ item }">
          <div class="text-center">{{ item.assetData.upload_direction }}</div>
        </template>

    </v-data-table>       
</template>
  
  <script>
import { computed } from 'vue';
  export default {
    data() {
      return {

       
      };
    },
    props: {
        headers: {
            type: Array,
            required: true
        },
        datas: {
            type: Array,
            required: true,
            default: () => []
        },
        load: {
          type: Boolean,
          required: true
        },
    },
    methods: {
        
    
    },
    computed: {
        itemsArr() {
          if(this.load && this.datas){
            // console.log("[테이블데이터] this.datas => ", this.datas)
            return this.datas;
          }
          return null;
        }
    },
    mounted(){
      if(this.datas && this.load){
        }
    }
  };
  </script>
  
  <style>
.data-table >>> .v-data-table__wrapper table tbody tr td {
    font-size: 13px;
}

.data-table >>> .v-data-footer__pagination {
  margin: 0; 
}
.data-table >>> .v-data-footer__icons-before {
  width: 20px;
}
  </style>
  